import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { AppsSettingUrlEnum, Lookup } from '../models/Lookup';

@Injectable({ providedIn: 'root' })
export class LookupsService {
  refreshList = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) {
  }

  GetMenu() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetResMenu`);
  }
  getCountries() {
    return this.http.get(`${environment.apiUrl}/Lookup/CountriesWeb`);
    return this.http.get(`${environment.apiUrl}/Lookup/Countries`);
  }
  getCities(countryId: number) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCitiesbyCountryId?CountryId=${countryId}`);
  }
  GetGender() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetGender`);
  }
  getNationalities() {
    return this.http.get(`${environment.apiUrl}/Lookup/Nationalities`);
  }
  getSystems() {
    return this.http.get(`${environment.apiUrl}/Lookup/Systems`);
  }
  getRoles() {
    return this.http.get(`${environment.apiUrl}/Roles/list`);
  }
  DefaultCurrency() {
    return this.http.get(`${environment.apiUrl}/Lookup/DefaultCurrency`);
  }
  GetAllCurrencies() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllCurrencies`);
  }
  PaymentMethods() {
    return this.http.get(`${environment.apiUrl}/Lookup/PaymentMethods`);
  }
  GetAllAmenities() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllAmenitiesList`);
  }
  GetIngredients() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetIngredients`);
  }
  GetTags() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetTags`);
  }
  RestaurantDefaultCurrency(restaurantId: any) {
    return this.http.get(`${environment.apiUrl}/Lookup/RestaurantDefaultCurrency?RestaurantId=${restaurantId}`);
  }
  GetStockUnit() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetStockUnit`);
  }
  GetCategory(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCategory?restaurantId=${restaurantId}`);
  }
  getResIngradiantFilter(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurantIngredient/getResIngradiantFilter?RestaurantId=${RestaurantId}`);
  }
  GetReportFeedBackReasons() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetReportFeedBackReasons`);
  }
  GetApplicationSettings(pageName: AppsSettingUrlEnum, lang: string) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetApplicationSettings?settingKey=${pageName}&lang=${lang}`);
  }
  GetPaymentMethodsForHouseAccountPayment(restId: number) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetPaymentMethodsForHouseAccountPayment?restId=${restId}`);
  }
  GetAllRestaurantMenuItems(restIds: number[]) {
    return this.http.post(`${environment.apiUrl}/ResMenu/GetAllRestaurantMenuItems`, { restaurantsId: restIds });
  }
  GetAllFoodAllergens() {
    return this.http.get<Lookup[]>(`${environment.apiUrl}/Lookup/GetAllFoodAllergens`);
  }
}
